import { useQuery } from '@tanstack/react-query';
import { fetchCompanyUsage } from './api';

export const COMPANY_USAGE_KEY = ['usage', 'company'] as const;

/** Customer-scoped tier (CLAUDE.md): short staleTime, refetch on focus. Cheap
 * on purpose — one indexed SUM over our own table, no Stripe read anywhere. */
export function useCompanyUsage() {
  return useQuery({
    queryKey: COMPANY_USAGE_KEY,
    queryFn: fetchCompanyUsage,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  });
}
